import { mediaScreen } from "assets/style/functions";
import styled from "styled-components";

export const RootWrapper = styled.div`
  display: ${({ isGeneral, isUnderMaintenance }) =>
    !isGeneral && !isUnderMaintenance && "flex"};
  justify-content: center;
  ${mediaScreen(`flex-direction: column-reverse;`, 768)};
`;
